"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IconListIcon_1 = __importDefault(require("./IconListIcon"));
exports.default = IconListIcon_1.default;
